module.exports = (Promise.resolve(__parcel__require__("./" + "Native.e38fec12.15f4250f.js"))).then(() => parcelRequire('6JuLy'));